/* ==========================================================================
   TRE EMME — CX predictive search: products under the search field while typing
   (Shopify /search/suggest.json). Enter or "Vedi tutti" still opens the full results page.
   ========================================================================== */
(() => {
  'use strict';

  const input = document.getElementById('cx-search-input');
  const box = document.querySelector('[data-cx-search-results]');
  if (!input || !box) return;
  const form = input.form;
  const suggest = document.querySelector('.cx-search__suggest');

  const esc = (str) => String(str == null ? '' : str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  // Same output as Liquid's `money` with the shop format (window.CX_MONEY_FORMAT, set in cx-head); suggest.json gives "200.00"
  const money = (price) => {
    const n = Math.round(parseFloat(price) * 100) / 100;
    if (Number.isNaN(n)) return '';
    const format = window.CX_MONEY_FORMAT || '€{{amount_with_comma_separator}}';
    const [int, dec] = n.toFixed(2).split('.');
    const group = (sep) => int.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount_with_comma_separator': return `${group('.')},${dec}`;
        case 'amount_no_decimals_with_comma_separator': return group('.');
        case 'amount_no_decimals': return group(',');
        case 'amount_with_apostrophe_separator': return `${group("'")}.${dec}`;
        default: return `${group(',')}.${dec}`;
      }
    }).replace(/&euro;/g, '€').replace(/&nbsp;/g, ' ');
  };

  const thumb = (src) => (src ? `${src}${src.includes('?') ? '&' : '?'}width=360` : '');

  const render = (q, data) => {
    const res = (data && data.resources && data.resources.results) || {};
    const products = (res.products || []).slice(0, 6);
    const all = `${form.action}?q=${encodeURIComponent(q)}&type=product&options%5Bprefix%5D=last`;
    if (!products.length) {
      box.innerHTML = `<p class="cx-search__empty">Nessun risultato per “${esc(q)}”. Prova con un brand o una categoria.</p>`;
      return;
    }
    const items = products.map((p) => {
      const sale = parseFloat(p.compare_at_price_max) > parseFloat(p.price);
      return `<li class="cx-search__item${p.available ? '' : ' is-out'}"><a href="${esc(p.url)}">
        <span class="cx-search__thumb">${p.image ? `<img src="${esc(thumb(p.image))}" alt="" loading="lazy">` : ''}</span>
        <span class="cx-search__vendor">${esc(p.vendor)}</span>
        <span class="cx-search__title">${esc(p.title)}</span>
        <span class="cx-search__price">${p.available ? esc(money(p.price)) : 'Esaurito'}${p.available && sale ? `<s>${esc(money(p.compare_at_price_max))}</s>` : ''}</span>
      </a></li>`;
    }).join('');
    // Products only: the predictive API returned internal collections too (donna|…, vendor|…), not hidden by Search & Discovery
    box.innerHTML = `
      <div class="cx-search__results-head"><p class="cx-label cx-muted">Prodotti</p><a class="cx-btn" href="${esc(all)}">Vedi tutti<span class="cx-btn__plus" aria-hidden="true"></span></a></div>
      <ul class="cx-search__grid" role="list">${items}</ul>`;
  };

  let timer;
  let controller;
  const run = () => {
    const q = input.value.trim();
    if (q.length < 2) {
      box.hidden = true;
      box.innerHTML = '';
      if (suggest) suggest.hidden = false;
      return;
    }
    if (controller) controller.abort();
    controller = new AbortController();
    const params = new URLSearchParams({
      q,
      'resources[type]': 'product',
      'resources[limit]': '8',
      'resources[options][unavailable_products]': 'hide',
      'resources[options][fields]': 'title,product_type,variants.title,vendor,tag',
    });
    fetch(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}search/suggest.json?${params}`, { signal: controller.signal })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (input.value.trim() !== q) return;
        render(q, data);
        box.hidden = false;
        if (suggest) suggest.hidden = true;
      })
      .catch(() => {});
  };

  input.addEventListener('input', () => {
    clearTimeout(timer);
    timer = setTimeout(run, 180);
  });
})();
